<script setup>
defineProps({
  validationErrors: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  label: {
    type: [String, null],
    required: false,
    default: null,
  },
});

defineOptions({
  inheritAttrs: false
})

const inputValue = defineModel({
  type: [Number],
  required: true,
});
</script>

<template>
  <div class="tw-relative tw-w-full">
    <div class="tw-flex tw-flex-col tw-w-full tw-gap-2">
      <label
        v-if="label"
        :for="$attrs.id"
        class="tw-text-font-neutral-900 tw-font-bold tw-text-base"
      >
        {{ label }}
      </label>
      <input
        v-model="inputValue"
        v-bind="$attrs"
        type="number"
        class="tw-h-13 tw-py-1 focus-within:tw-border-primary tw-border-neutral visible-number-controls tw-resize-none tw-border tw-text-neutral-900 tw-self-stretch tw-px-6 tw-text-base tw-w-full tw-rounded-lg"
        :class="{
          '!tw-border-danger': validationErrors.length > 0,
        }"
      >
    </div>
  </div>
</template>
